import React, {Component} from "react";
import {
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Input,
  InputLabel,
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import {red} from "@material-ui/core/colors";
import {Formik} from "formik";
import {getUpdateFormImageUrlFromItem, getValueFromQueryParam, makeImageUrl} from "../../utils";
import browserHistory from "../../utils/browserHistory";
import {request} from "../../api-client";

import GlobalSnackbar, {GlobalSnackbarTypes} from "../../components/Letflow/Snackbar/GlobalSnackbar";
import localization from "../../config/localization";
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import TranslatableInputs from "../../components/Letflow/TranslatableInputs";
import AsyncSelect from "react-select/lib/Async";
import {VideoPicker} from "../../components/Letflow/Form";
import FilePondUploader from "../../components/Letflow/FilePondUploader";
import RichTextEditor from "../../components/Letflow/RichTextEditor";
import {stateToHTML} from "draft-js-export-html";
import {EditorState, ContentState, convertFromHTML} from "draft-js";


const flowlikeBanner = {value: 0, label: "Bloomclouds"}

class VideoForm extends Component {
  state = {
    changingVideo: false,
    changingAudio: false,
    changingPreview: false,
  };


  formNewUrl = (path) => {
    return process.env.REACT_APP_CDN_HOST.concat('/' + path)
  }

  onVideoChange = video => video ? this.setState({videoId: video.id, video: {src: null}, videoPreview: this.formNewUrl(video.path)}) : this.setState({videoId: null, video: {src: null}})
  onPreviewChange = preview => preview ? this.setState({previewId: preview.id, preview: {src: null}, videoPreview: this.formNewUrl(preview.path)}) : this.setState({previewId: null, preview: {src: null}})

  setPreview = (type) => {
    if (type === 'video') {
      this.setState({video: { src: this.state.videoPreview, filename: null}})
    } else if (type === 'image') {
      let item = {image: {id: this.state.imageId, src: this.state.imagePreview}}
      this.setState({image : {src: getUpdateFormImageUrlFromItem(item)}})
    }
  }



  render = () => {
    const {
      video,
      preview,
      type = "home_banner",
      title = "",
      subtitleEs = "",
      descriptionEs = new EditorState.createEmpty(),
      subtitleEn = "",
      descriptionEn = new EditorState.createEmpty(),
      active = 1,
      videoId = undefined,
      onSubmitStart,
      onSubmitEnd,
      onSubmitProgress,
      platformBanner,
      clients
    } = this.props;

    const isUpdating = Boolean(videoId);

    let imageInput;

    return (
      <Formik
        initialValues={{ type, title, subtitleEs, descriptionEs, subtitleEn, descriptionEn, active, clients, platformBanner, preview, video, disableForm: false }}
        validate={values => {
          const errors = {};
          if (!values.type) {
            errors.type = localization.get('video.must_select_type')
          }

          if (!values.title) {
            errors.title = localization.get('video.title_required')
          }

          if (values.clients && values.clients.length === 0) {
            errors.clients = localization.get('video.must_select_clients')
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          onSubmitStart();
          const data = {
            translations: [
              {language: 'es', subtitle: values.subtitleEs, description: stateToHTML(values.descriptionEs.getCurrentContent())},
              {language: 'en', subtitle: values.subtitleEn, description: stateToHTML(values.descriptionEn.getCurrentContent())},
            ],
            title: values.title,
            type: "home_banner",
            active: values.active,
            clients: values.clients,
            platformBanner: values.platformBanner,
            videoId: this.state.videoId,
            previewId: this.state.previewId
          };
          request.authentication
            .refreshAccessToken()
            .then(() => {
              if (isUpdating) {
                return request.featuredVideo.update(videoId, data, onSubmitProgress);
              }
              return request.featuredVideo.create(data, onSubmitProgress);
            })
            .then(() => browserHistory.goBack())
            .finally(() => {
              onSubmitEnd();
              setSubmitting(false);
            });
        }}
      >
        {({
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
        }) => {
          return (
            <div style={{ display: "flex",
              flexDirection: "column",
              backgroundColor: "white",
              padding: "20px 30px" }}>
              {(() => {
                return (
                  values.url &&
                  !Boolean(errors.url) && (
                    <div style={{ marginBottom: 15 }}>
                      <video src={values.url} style={{maxWidth: "600px", width: "100%"}} controls autoPlay />
                    </div>
                  )
                );
              })()}
              {/** Video */}
              <>
                <h4>{localization.get('video')}</h4>
                {values.video && <VideoPicker video={values.video.src} previewOnly={true}/>}
                <FilePondUploader
                  file={video}
                  id={"video"}
                  type={"video"}
                  allowedTypes={["video/mp4","video/x-m4v","video/*",".mov"]}
                  onIdChange={this.onVideoChange}
                  setPreview={this.setPreview}
                  disableForm={values.disableForm}
                  updateDisableForm={value => setFieldValue('disableForm', value)}
                  maxFileSize={"300MB"}
                />
                <br/>
                <br/>
              </>
              <div style={{color: "#757575",  marginTop: 5}}>{localization.get('helper_text.video_720_50mb')}</div>
              <br />
              {/** Audio */}
              <br />
              {/** Preview Video */}
              <>
                <h4>{localization.get('form.select_video_preview')}</h4>
                {values.preview && <VideoPicker video={values.preview.src} previewOnly={true}/>}
                <FilePondUploader
                  file={video}
                  id={"preview"}
                  type={"video"}
                  allowedTypes={["video/mp4","video/x-m4v","video/*",".mov"]}
                  onIdChange={this.onPreviewChange}
                  setPreview={this.setPreview}
                  disableForm={values.disableForm}
                  updateDisableForm={value => setFieldValue('disableForm', value)}
                  maxFileSize={"10MB"}
                />
                <br/>
                <br/>
              </>
              <div style={{color: "#757575",  marginTop: 5}}>{localization.get('helper_text.video_720_5mb')}</div>
              <br />
              {/** Image */}
              {/*{this.renderImagePicker({ values, setFieldTouched, setFieldValue })}*/}
              {/*<div style={{color: "#757575",  marginTop: 5}}>{localization.get('helper_text.images_width_2048')}</div>*/}
              {/*<br />*/}
              {/** Type */}
                <FormControl fullWidth>
                  <span>{localization.get('clients.visible_for_managed')}</span>
                  <AsyncSelect
                    styles={{
                      menu: base => ({
                        ...base,
                        zIndex: 10
                      })
                    }}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0
                    })}
                    placeholder={localization.get('clients')}
                    loadingMessage={() => localization.get('loading')}
                    noOptionsMessage={() => localization.get('no_options')}
                    onChange={e => setFieldValue("clients", e)}
                    value={values.clients}
                    loadOptions={inputValue =>
                      request.client
                        .getAll({
                          filterBy: [{column: "name", filter: inputValue}, {
                            column: "can_manage_clients",
                            filter: "1"
                          }]
                        })
                        .then(res => {
                          let clients = res.map(client => ({value: client.id, label: client.name}))
                          clients.push(flowlikeBanner)

                          return clients
                        })
                    }
                    isMulti={true}
                    defaultOptions
                  />
                  {errors.clients && touched.clients && <FormHelperText error={true}>{errors.clients}</FormHelperText>}
              </FormControl>
              <br />
              {/** Title */}
              <FormControl error={errors.title && touched.title}>
                <InputLabel>{localization.get('form.title')}</InputLabel>
                <Input
                  name={"title"}
                  value={values.title}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={isSubmitting}
                />
                {errors.title && touched.title && <FormHelperText>{errors.title}</FormHelperText>}
              </FormControl>
              <br />
              {/** Active */}
              <FormControlLabel
                control={
                  <Checkbox
                    name={"active"}
                    style={{ color: "black" }}
                    checked={values.active}
                    onChange={handleChange}
                    disabled={isSubmitting}
                  />
                }
                label={localization.get('form.active')}
              />

              {/** Translatable */}
              <ValidatorForm>
                <TranslatableInputs
                  children={[
                    {
                      language: 'es',
                      content: [
                        <TextValidator
                          style={{ width: "100%", marginBottom: "20px" }}
                          id="subtitleEs"
                          label={localization.get('form.subtitle')}
                          name="subtitleEs"
                          value={values.subtitleEs}
                          onChange={handleChange}
                          disabled={isSubmitting}
                        />,
                        <TextValidator
                          style={{display: "none"}}
                          id="descriptionEs"
                          name="descriptionEs"
                          onChange={handleChange}
                          value={stateToHTML(values.descriptionEs.getCurrentContent())}
                          isHtml={true}
                        />,
                        <div style={{marginBottom: "-2rem"}}>{localization.get('form.description')}</div>,
                        <RichTextEditor
                          editorState={values.descriptionEs}
                          onChange={value => {
                                setFieldValue('descriptionEs', value)
                                setFieldTouched('descriptionEs', true)
                              }}
                        />
                      ]
                    },
                    {
                      language: 'en',
                      content: [
                        <TextValidator
                          style={{ width: "100%", marginBottom: "20px" }}
                          id="subtitleEn"
                          label={localization.get('form.subtitle')}
                          name="subtitleEn"
                          value={values.subtitleEn}
                          onChange={handleChange}
                          disabled={isSubmitting}
                        />,
                        <TextValidator
                          style={{display: "none"}}
                          id="descriptionEn"
                          name="descriptionEn"
                          onChange={handleChange}
                          value={values.descriptionEn}
                          isEditorState={true}
                        />,
                        <div style={{marginBottom: "-2rem"}}>{localization.get('form.description')}</div>,
                        <RichTextEditor
                          editorState={values.descriptionEn}
                          onChange={value => {
                            setFieldValue('descriptionEn', value)
                            setFieldTouched('descriptionEn', true)
                          }}
                        />
                      ]
                    }
                  ]}
                />
              </ValidatorForm>

              <br />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button onClick={() => browserHistory.goBack()} color="default" disabled={isSubmitting}>
                  {localization.get('form.back')}
                </Button>
                <Button onClick={handleSubmit} color="info" disabled={isSubmitting || values.disableForm}>
                  {localization.get('form.submit')}
                </Button>
              </div>
            </div>
          );
        }}
      </Formik>
    );
  };

  renderVideoPicker = ({ values, touched, errors, setFieldValue, setFieldTouched }) => (
    <div>
      <input
        ref={r => (this.videoInput = r)}
        type="file"
        accept="video/mp4,video/x-m4v,video/*,.mov"
        onChange={e => {
          this.setState({ changingVideo: true });
          setTimeout(() => {
            this.setState({ changingVideo: false });
          }, 500);
          this.handleFileChanged({ valueName: "video", setFieldValue, setFieldTouched })(e);
        }}
        hidden
      />

      <div>
        <Button
          variant="contained"
          style={{
            backgroundColor: errors.video && touched.video && red["400"],
            color: errors.video && touched.video && "white",
          }}
          onClick={() => this.videoInput.click()}
        >
          {localization.get('video.select_video')}
        </Button>
      </div>

      {errors.video && touched.video && <div style={{ marginTop: 10, color: "red" }}>{errors.video}</div>}
      {values.video.src && !this.state.changingVideo && (
        <div>
          <br />
          <video ref={r => (this.videoDisplay = r)} style={{ maxWidth: "600px", width: "100%" }} controls>
            <source src={values.video.src} type="video/mp4" />
            <source src={values.video.src} type="video/mov" />
          </video>
        </div>
      )}
    </div>
  );

  renderPreviewPicker = ({ values, touched, errors, setFieldValue, setFieldTouched }) => (
    <div>
      <input
        ref={r => (this.previewInput = r)}
        type="file"
        accept="video/mp4,video/x-m4v,video/*,.mov"
        onChange={e => {
          this.setState({ changingPreview: true });
          setTimeout(() => {
            this.setState({ changingPreview: false });
          }, 500);
          this.handleFileChanged({ valueName: "preview", setFieldValue, setFieldTouched })(e);
        }}
        hidden
      />
      <div>
        <Button
          variant="contained"
          style={{
            backgroundColor: errors.preview && touched.preview && red["400"],
            color: errors.preview && touched.preview && "white",
          }}
          onClick={() => this.previewInput.click()}
        >
          {localization.get('video.select_preview_video')}
        </Button>
      </div>
      {errors.preview && touched.preview && <div style={{ marginTop: 10, color: "red" }}>{errors.preview}</div>}
      {values.preview.src && !this.state.changingPreview && (
        <div>
          <br />
          <video ref={r => (this.videoDisplay = r)} style={{ maxWidth: "600px", width: "100%" }} controls>
            <source src={values.preview.src} type="video/mp4" />
            <source src={values.preview.src} type="video/mov" />
          </video>
        </div>
      )}
    </div>
  );

  renderAudioPicker = ({ values, touched, errors, setFieldValue, setFieldTouched }) => (
    <div>
      <input
        ref={r => (this.audioInput = r)}
        type="file"
        accept="audio/mp3"
        onChange={e => {
          this.setState({ changingAudio: true });
          setTimeout(() => {
            this.setState({ changingAudio: false });
          }, 500);
          this.handleFileChanged({ valueName: "audio", setFieldValue, setFieldTouched })(e);
        }}
        hidden
      />
      <div>
        <Button
          variant="contained"
          style={{
            backgroundColor: errors.audio && touched.audio && red["400"],
            color: errors.audio && touched.audio && "white",
          }}
          onClick={() => this.audioInput.click()}
        >
          {localization.get('video.select_audio')}
        </Button>
      </div>
      {errors.audio && touched.audio && <div style={{ marginTop: 10, color: "red" }}>{errors.audio}</div>}
      {values.audio.src && !this.state.changingAudio && (
        <div>
          <br />
          <audio ref={r => (this.audioDisplay = r)} src={values.audio.src} controls/>
        </div>
      )}
    </div>
  );

  renderImagePicker = ({ values, setFieldTouched, setFieldValue }) => (
    <div>
      <input
        ref={r => (this.imageInput = r)}
        type="file"
        accept="image/*"
        onChange={this.handleFileChanged({ valueName: "image", setFieldValue, setFieldTouched })}
        hidden
      />
      <div>
        <Button variant="contained" onClick={() => this.imageInput.click()}>
          {localization.get('video.select_logo')}
        </Button>
      </div>
      {values.image.src && (
        <div>
          <br />
          <img style={{width: "100%", maxWidth: "600px"}} src={values.image.src} />
        </div>
      )}
    </div>
  );

  handleFileChanged = ({ valueName, setFieldValue, setFieldTouched }) => e => {
    const file = e.target.files[0];
    setFieldTouched(valueName, true);

    if (!file) {
      setFieldValue(valueName, { src: null, file: null });
    }

    else if(file && file.size > (valueName === 'preview' ? 5000000 : 50000000)) {
      GlobalSnackbar.show({
        message: localization.get('config_video.video_max_size', (valueName === 'preview'? `5` : `50`)),
        type: GlobalSnackbarTypes.ERROR,
        topDistance: 100,
      })
    } else {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFieldValue(valueName, { src: reader.result, file });
      };
      reader.readAsDataURL(file);
    }
  };
}

class VideoFormHandler extends Component {
  state = {
    showProgress: false,
    progressPercentage: 0,
    renderForm: () => null,
  };

  componentDidMount = () => {
    if (this.videoId() !== undefined) {
      this.requestVideo().then(video =>
        this.setState({
          renderForm: () => (
            <VideoForm
              {...video}
              videoId={this.videoId()}
              onSubmitStart={this.onSubmitStart}
              onSubmitEnd={this.onSubmitEnd}
              onSubmitProgress={this.onSubmitProgress}
            />
          ),
        })
      );
    } else {
      let type = getValueFromQueryParam("type");
      this.setState({
        renderForm: () => (
          <VideoForm
            type={type}
            onSubmitStart={this.onSubmitStart}
            onSubmitEnd={this.onSubmitEnd}
            onSubmitProgress={this.onSubmitProgress}
          />
        ),
      });
    }
  };

  videoId = () => this.props.match.params.videoId;

  onSubmitStart = () => {
    this.setState({ showProgress: true });
  };

  onSubmitEnd = () => {
    this.setState({ showProgress: false });
  };

  onSubmitProgress = (current, total) => {
    this.setState({ progressPercentage: Math.round((current / total) * 100) });
  };

  requestVideo = () =>
    request.featuredVideo.find(this.videoId()).then(video => {
      let translationEs = video.translations.find(translation => translation.locale === 'es')
      let translationEn = video.translations.find(translation => translation.locale === 'en')

      let clients = video.clients && video.clients.map(clients => ({
          value: clients.id,
          label: clients.name
        }))

      video.platform_banner && clients.push(flowlikeBanner)

      return ({
        video: { src: video.video && video.video.url, file: null },
        preview: {src: video.preview && video.preview.url, file: null},
        audio: {src: video.audio && video.audio.url, file: null},
        image: { src: video.image && makeImageUrl(video), file: null },
        type: video.type,
        title: video.title,
        subtitleEs: translationEs && translationEs.subtitle,
        descriptionEs: (translationEs && translationEs.description) ? EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(translationEs.description).contentBlocks, convertFromHTML(translationEs.description).entityMap)) : new EditorState.createEmpty(),
        subtitleEn: translationEn && translationEn.subtitle,
        descriptionEn: (translationEn && translationEn.description) ? EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(translationEn.description).contentBlocks, convertFromHTML(translationEn.description).entityMap)) : new EditorState.createEmpty(),
        active: video.active,
        clients: clients,
        platformBanner: video.platform_banner
      })
    });

  renderSubmittingDialog = () =>
    this.state.showProgress && <SubmittingDialog progressPercentage={this.state.progressPercentage} />;

  render = () => (
    <div>
      {this.renderSubmittingDialog()}
      {this.state.renderForm()}
    </div>
  );
}

const SubmittingDialog = ({ progressPercentage }) => (
  <Dialog open>
    <DialogTitle>{localization.get('video.sending')}</DialogTitle>
    <DialogContent style={{ display: "flex", justifyContent: "center", position: "relative" }}>
      <CircularProgress style={{ color: "#dadada" }} size={60} />
      <span style={{ position: "absolute", top: 20 }}>{progressPercentage}%</span>
    </DialogContent>
  </Dialog>
);

export default VideoFormHandler;
